import AddOn from "../Components/Master/AddOn/AddOn";
import Dashboard from "../Components/Page/Dashboard";
import Login from "../Components/Page/Login";
import PrivacyPolicyMobile from "../Components/PrivacyPolicy/privacyPolicy";
import LoginWrapper from "../Components/Login/LoginWrapper";
import { isBriskV2Enabled, BRISK_V2_LIST_PATH, BRISK_V2_MONEY_PATHS } from "../Shared/briskV2Flag";
import { ROADZEN_CERT_LIST_PATH, ROADZEN_COMPANY_WALLET_PATH, ROADZEN_CREATE_CERT_PATH, ROADZEN_USERS_PATH, ROADZEN_WALLET_PATH } from "../Components/Roadzen/roadzenPaths";

const Routes = [
  {
    path: "/login",
    exact: false,
    element: LoginWrapper,
    isAuthenticated: false,
  },
  {
    path: "/privacyPolicy",
    exact: false,
    element: PrivacyPolicyMobile,
    isAuthenticated: false,
  },

  {
    path: "/",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/dashboard",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/branch",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/company",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/bookingcode",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/linkbookingcode",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/linksupplier",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policyperiod",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policytype",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/product",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/masterCompany",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/user",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/renewalPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/companyLogin",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/commisionReceivale",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/receivaleStatus",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/userPayable",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/branchPayable",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/officeExpenses",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/masterReport",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/chequeStatus",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/logStatus",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policyChequeReport",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/receivableBulkUpload",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/rayalchat-users-info",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/paymentPaidAndReceived",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policycreate",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/searchPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/receivableStatusNew",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policyList",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/bulkUploadedPolicyList",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/ccentry",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/policyMapping",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/motorCalculation",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/userConfiguration",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  // Added by Arun
  {
    path: "/commonConfiguration",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/allPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/approvedPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/pendingPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/entryPending",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/rejectedPolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/chequePending",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/client",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    // Server Control (super admin only — the page itself refuses anyone else)
    path: "/serverControl",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/clientSignUp",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/subProduct",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/subBookingCode",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/fuelType",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/payout",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/userWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/motorWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/branchWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/companyWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/clientCompanyWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/clientCompanyWallet/:clientId",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/adminPolicyWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/userPolicyWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/addPolicyWalletMoney",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/receivableConfiguration",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/branchConfiguration",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/rtoMapping",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/tdsReport",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/bookingReport",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/vehicleMake",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/makeModel",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/makeModelCombo",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/masterChangeLog",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/financier",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/MotorReport",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/addon",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/onlinePolicy",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskCreateCertificate",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  // RoadZen Users and Wallet (CLIENT logins; the server refuses everyone else)
  {
    path: ROADZEN_USERS_PATH,
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: ROADZEN_WALLET_PATH,
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: ROADZEN_COMPANY_WALLET_PATH,
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: ROADZEN_CREATE_CERT_PATH,
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: ROADZEN_CERT_LIST_PATH,
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/onlinePolicy/edit/:policyId",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/onlinePolicy/view/error_logs/:policyId",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    // the policy's History as a page (2026-10-22)
    path: "/onlinePolicy/view/history/:policyId",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/onlinePolicy/view/form/:policyId",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskWallet",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskTransactionHistory",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/rtoCityLocation",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/nilDip",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  // girnar routes
  {
    path: "/briskCreateCertificates",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskDownloadCertificate",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskTransactionHistorys",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  {
    path: "/briskWallets",
    exact: false,
    element: Dashboard,
    isAuthenticated: true,
  },
  // Brisk certificates (new, "V2") — only while REACT_APP_BRISK_V2_ENABLED is "true".
  ...(isBriskV2Enabled()
    ? [
        {
          path: BRISK_V2_LIST_PATH,
          exact: false,
          element: Dashboard,
          isAuthenticated: true,
        },
        // Brisk Wallet, Transaction History, Transaction Report (admin only: the server refuses everyone else)
        ...BRISK_V2_MONEY_PATHS.map((path) => ({ path, exact: false, element: Dashboard, isAuthenticated: true })),
      ]
    : []),
];
export default Routes;

